import { Icon } from '../../ui/Icon.js';

/**
 * GEO vs. SEO, side by side.
 *
 * SEO = a ranked list of blue links (you compete for position). GEO = being
 * named and cited inside the single synthesized answer. Pure CSS/HTML.
 */
export function GeoVsSeoDiagram() {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {/* SEO */}
      <div className="rounded-xl border border-[var(--hub-color-line)] bg-[var(--hub-color-surface)] p-4">
        <div className="mb-3 flex items-center gap-2 text-[var(--hub-color-ink-muted)]">
          <Icon name="bx-link-alt" />
          <span className="text-xs font-semibold">SEO, blue links</span>
        </div>
        <ol className="space-y-2">
          {[1, 2, 3].map((rank) => (
            <li key={rank} className="flex items-center gap-2">
              <span className="hub-num hub-num--sm" aria-hidden="true">{rank}</span>
              <span className="h-2.5 flex-1 rounded-[var(--hub-radius-control)] bg-[var(--hub-color-line)]" />
            </li>
          ))}
        </ol>
        <p className="mt-3 text-xs text-[var(--hub-color-ink-subtle)]">Compete for a rank in the list.</p>
      </div>

      {/* GEO */}
      {/* Spec 250 (review P1-10, P1-15): sentence-case labels, and the side
          that matters marked with an ink rule — not a Skagen-tinted panel. */}
      <div className="rounded-xl border border-[var(--hub-color-ink)] bg-[var(--hub-color-surface)] p-4">
        <div className="mb-3 flex items-center gap-2 text-[var(--hub-color-ink)]">
          <Icon name="bx-message-detail" />
          <span className="text-xs font-semibold">GEO, the answer</span>
        </div>
        <div className="rounded-lg border border-[var(--hub-color-line)] bg-[var(--hub-color-surface-sunken)] p-3">
          <p className="text-sm leading-relaxed text-[var(--hub-color-ink)]">
            “For flat feet, a popular pick is{' '}
            <mark className="bg-transparent font-semibold text-[var(--hub-color-ink)] underline decoration-2 underline-offset-2">
              your brand
            </mark>
            , often cited for stability…”
          </p>
        </div>
        <p className="mt-3 text-xs text-[var(--hub-color-ink-muted)]">Be mentioned and cited in the answer itself.</p>
      </div>
    </div>
  );
}
